import { Principal } from "@dfinity/principal";
import type { Signer } from "@slide-computer/signer";

interface CallOptions {
  canisterId: Principal;
  sender: Principal;
  method: string;
  arg: ArrayBuffer;
}

interface CallResponse {
  content_map: ArrayBuffer;
  certificate: ArrayBuffer;
}

export class Scheduler {
  #signer: Pick<
    Signer,
    "callCanister" | "batchCallCanister" | "supportedStandards"
  >;
  #supportsBatch: boolean;
  #executeTimeout?: ReturnType<typeof setTimeout>;
  #calls: Array<{
    options: CallOptions;
    resolve: (response: CallResponse) => void;
    reject: (error: unknown) => void;
  }> = [];
  #ongoing: Promise<void> = Promise.resolve();

  constructor(supportsBatch: boolean) {
    this.#supportsBatch = supportsBatch;
  }

  async call(
    options: CallOptions,
  ): Promise<{ content_map: ArrayBuffer; certificate: ArrayBuffer }> {
    return new Promise((resolve, reject) => {
      clearTimeout(this.#executeTimeout);
      this.#calls.push({ options, resolve, reject });
      this.#executeTimeout = setTimeout(() => {
        this.#calls.push({ options, resolve, reject });
      }, 100);
      // this.#ongoing = this.#ongoing.finally(async () => {
      //   try {
      //     resolve(await job());
      //   } catch (error) {
      //     reject(error);
      //   }
      // });
    });
  }
}
